import React from 'react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, SectionSubTitle, SectionTitle } from 'common/components';
import { RACK_SECTION_DATA } from './rack-section-constants';

const rackSection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--only-mobile) {
    margin-bottom: 56px;
  }
`;

const rackSectionName = css`
  @media (--to-desktop) {
    margin-bottom: 40px;
  }

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

const rackWrapper = css`
  display: flex;
  justify-content: space-between;

  @media (--only-mobile) {
    flex-direction: column;
  }
`;

const rack = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
  padding: 20px 20px 12px;

  @media (--only-desktop) {
    width: 220px;
    padding: 0 5px 0 0;
  }

  @media (--only-tablet) {
    width: 178px;
    padding: 0;
  }

  @media (--only-mobile) {
    position: relative;
    align-items: flex-start;
    width: 288px;
    height: 147px;
    padding: 30px 0 29px 160px;
    margin: 0 0 24px;
    text-align: left;
  }
`;

const rackName = css`
  && {
    text-align: center;

    @media (--only-mobile) {
      font-size: 26px;
      line-height: 32px;
      text-align: left;
    }
  }
`;

const rackImage = css`
  width: 234px;
  height: 250px;
  margin-bottom: 32px;

  @media (--only-desktop) {
    width: 215px;
    height: 230px;
  }

  @media (--only-tablet) {
    width: 178px;
    height: 190px;
  }

  @media (--only-mobile) {
    position: absolute;
    top: 0;
    left: 0;
    width: 138px;
    height: 147px;
    margin-bottom: 0;
  }
`;

const rackButton = css`
  && {
    padding: 6px 16px;
    font-size: 16px;
    line-height: 24px;
  }
`;

/**
 * Вью секции "Стеллажи разных цветов"
 */
export const RacksSection = () => (
  <section className={rackSection}>
    <SectionTitle className={rackSectionName}>Стеллажи разных цветов</SectionTitle>

    <div className={rackWrapper}>
      {RACK_SECTION_DATA.map(({ name, alt, src, href }) => (
        <div key={href} className={rack}>
          <SectionSubTitle as="h3" className={rackName} margin="m" adaptiveMargin>
            {name}
          </SectionSubTitle>
          <img alt={alt} className={rackImage} loading="lazy" src={src} title={alt} />
          <ButtonWithGAClickButton
            className={rackButton}
            elementBlock="landingSpaceoKub"
            elementName={name}
            elementText="Посмотреть"
            href={href}
            title="Посмотреть все стеллажи этого цвета">
            Посмотреть
          </ButtonWithGAClickButton>
        </div>
      ))}
    </div>
  </section>
);
